import { Link } from "@amzn/awsui-components-react-v3";
import React from "react";
import "./permissions_page.css";

export const PermissionsPageHelpPanelContent: React.FC = (): JSX.Element => {
  return (
    <React.Fragment>
      <div>
        <p>
          The Permissions tab displays a list of users with their level of
          access type.
        </p>
        <h3>Team owner</h3>
        <p>
          The Team owner automatically inherits Admin access. Learn how to
          update the team owner{" "}
          <Link
            external
            externalIconAriaLabel="Opens in a new tab"
            href="https://w.amazon.com/bin/view/Roster2/Help/Managing_Teams/#HHowdoIassignand2ForupdateaTeamOwner3F"
          >
            here
          </Link>
          .
        </p>
        <h3>Managing permissions</h3>
        <p>
          To grant user permissions, select Add users button, search by employee
          name or alias, and select Save changes.
          <br />
          <br />
          To remove user permissions, under Actions select Remove next to the
          user&apos;s name. A confirmation message will display; review and
          confirm deletion by selecting Remove. Admins who inherit access can
          only be removed from the top-level Team page they are inheriting
          access from.
        </p>
        <p>
          Learn more about permissions{" "}
          <Link
            external
            externalIconAriaLabel="Opens in a new tab"
            href="https://w.amazon.com/bin/view/Roster2/Help/ManagingPermissions/"
          >
            here
          </Link>
          .
        </p>
      </div>
    </React.Fragment>
  );
};

export default PermissionsPageHelpPanelContent;
